import { render, staticRenderFns } from "./LearningList.vue?vue&type=template&id=56715b16&"
import script from "./LearningList.vue?vue&type=script&lang=js&"
export * from "./LearningList.vue?vue&type=script&lang=js&"
import style0 from "./LearningList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports